import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './i18n';
import './index.css';

import Navbar from './components/Navbar.jsx';
import Footer from './components/Footer.jsx';
import CookieBanner from './components/CookieBanner.jsx';

import HomePage from './pages/HomePage.jsx';
import GroupPage from './pages/GroupPage.jsx';
import AccessoriesPage from './pages/AccessoriesPage.jsx';
import TelecomPage from './pages/TelecomPage.jsx';
import RetailTechPage from './pages/RetailTechPage.jsx';
import EcosystemPage from './pages/EcosystemPage.jsx';
import ContactPage from './pages/ContactPage.jsx';
import LegalPage from './pages/LegalPage.jsx';
import PrivacyPage from './pages/PrivacyPage.jsx';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

// Language direction handler
function LanguageHandler() {
  const { i18n } = useTranslation();
  
  useEffect(() => {
    const lang = i18n.language;
    const dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.dir = dir;
    document.documentElement.lang = lang;
  }, [i18n.language]);
  
  return null;
}

// Layout wrapper
function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <LanguageHandler />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/groupe" element={<GroupPage />} />
          <Route path="/accessoires" element={<AccessoriesPage />} />
          <Route path="/telecom" element={<TelecomPage />} />
          <Route path="/bureau-etude" element={<RetailTechPage />} />
          <Route path="/ecosysteme" element={<EcosystemPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/mentions-legales" element={<LegalPage />} />
          <Route path="/confidentialite" element={<PrivacyPage />} />
          
          {/* Localized routes */}
          <Route path="/fr" element={<HomePage />} />
          <Route path="/fr/groupe" element={<GroupPage />} />
          <Route path="/fr/accessoires" element={<AccessoriesPage />} />
          <Route path="/fr/telecom" element={<TelecomPage />} />
          <Route path="/fr/bureau-etude" element={<RetailTechPage />} />
          <Route path="/fr/ecosysteme" element={<EcosystemPage />} />
          <Route path="/fr/contact" element={<ContactPage />} />
          
          <Route path="/en" element={<HomePage />} />
          <Route path="/en/group" element={<GroupPage />} />
          <Route path="/en/accessories" element={<AccessoriesPage />} />
          <Route path="/en/telecom" element={<TelecomPage />} />
          <Route path="/en/engineering" element={<RetailTechPage />} />
          <Route path="/en/ecosystem" element={<EcosystemPage />} />
          <Route path="/en/contact" element={<ContactPage />} />
          
          <Route path="/ar" element={<HomePage />} />
          <Route path="/ar/groupe" element={<GroupPage />} />
          <Route path="/ar/accessories" element={<AccessoriesPage />} />
          <Route path="/ar/telecom" element={<TelecomPage />} />
          <Route path="/ar/engineering" element={<RetailTechPage />} />
          <Route path="/ar/ecosystem" element={<EcosystemPage />} />
          <Route path="/ar/contact" element={<ContactPage />} />
          
          {/* Fallback - 404 */}
          <Route path="*" element={<HomePage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
